import { Trans, useTranslation } from 'react-i18next';

import classes from '../FRBWidget.module.scss';

export function CountdownType({ countdownMinutes }: { countdownMinutes: number }) {
  const { t } = useTranslation();
  return (
    <div className={classes.countdownType}>
      <div className={classes.inner}>
        <div className={classes.title}>{t('frb.freeSpins')}</div>
        <div className={classes.details} data-testid="frb-countdown-details">
          <span>
            <Trans i18nKey="frb.countdownDetails" values={{ seconds: countdownMinutes }} />
          </span>
        </div>
      </div>
    </div>
  );
}
